import React, { useState, useEffect } from 'react'
import { Drawer, Flex, Result, Tabs, Tag, Typography } from 'antd'
import moment from 'moment'
import { CheckOutlined, CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import AuthService from '../auth/AuthService';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import 'jspdf-autotable';
import { styled } from '@mui/material';
import { showMessage } from '../Utils/message';
import DetailsGrid from '../common/DetailsGrid';
import StockDiscrepancyTab from '../Tabs/StockDiscrepancyTab';
import GoodsReturnTab from '../Tabs/GoodsReturnTab';
import dayjs from 'dayjs';

const Auth = new AuthService();
const DataSheet = styled('div')`
    .ant-input-outlined[disabled] {
      background-color: none;
      color: black;
      font-weight: 500;
    }
`;

const ReturnDrawer = ({ deliveryDate, drawerOpen, selectedRoute, handleCloseDrawer }) => {
    console.log('deliveryDate', deliveryDate);

    const { Text } = Typography;
    const layoutDispatch = useLoadingDispatch()
    const [activeTab, setActiveTab] = useState('1');
    const [routeReturnData, setRouteReturnData] = useState([]);

    const onTabChange = (key) => {
        setActiveTab(key);
        getRouteData(key);
    };

    useEffect(() => {
        if (drawerOpen) {
            setActiveTab("1");
            getRouteData("1")
        }
    }, [drawerOpen]);

    const getStockBatches = async () => {
        try {
            const response = await Auth.fetch(`/route/route-packing-batches-returns?route_status_id=${selectedRoute?.id}`);
            if (response?.ack) {
                const data = response?.route_batches
                return data;
            } else {
                showMessage('error', response?.message)
                return [];
            }
        } catch (err) {
            console.log(err);

        }
    }

    const getRouteData = async (key) => {
        setRouteReturnData([]);
        showLoading(layoutDispatch);
        try {
            const res = await Auth.fetch(`/route/load-route-returns?route_status_id=${selectedRoute?.id}`);
            if (res?.ack) {
                console.log(res);
                const newData = res?.daily_returns || [];
                const goodsUpdate = newData.map(item => {
                    const returnedQty = Number(item?.packed_quantity) - Number(item?.delivered_quantity);
                    const remaining_quantity_returned = (Number(item.packed_quantity) - Number(item.delivered_quantity)) - Number(item.returned_quantity)
                    return { ...item, returnedQty, remaining_quantity_returned }
                });
                if (key === "1") {
                    setRouteReturnData(goodsUpdate || []);
                } else {
                    const stockdata = await getStockBatches()
                    if (stockdata?.length) {
                        const stockUpdate = newData.map(item => {
                            const returnedQty = Number(item?.packed_quantity) - Number(item?.delivered_quantity);
                            return { ...item, returnedQty }
                        });

                        console.log('merge stockData', stockUpdate,);


                        const mergedArray = stockUpdate.flatMap(mainItem => {
                            const batches = stockdata.filter(b => b.item_pallet_id === mainItem.item_pallet_id);

                            if (batches.length > 0) {
                                return batches.map(batch => ({
                                    ...mainItem,
                                    batch_code: batch.batch_code,
                                    supplier_batch_code: batch.supplier_batch_code,
                                    batch_quantity: batch.quantity,
                                    returned_quantity: batch?.returned_quantity || 0,
                                    batch_id: batch?.id,
                                    expiry_date: batch?.expiry_date,
                                    purchase_order_details_batch_id: batch?.purchase_order_details_batch_id,

                                }));
                            } else {
                                // No batch → add empty batch fields
                                return {
                                    ...mainItem,
                                    batch_code: "",
                                    supplier_batch_code: "",
                                    batch_quantity: 0,
                                    returned_quantity: 0,
                                    batch_id: 0,
                                    expiry_date: null,
                                    purchase_order_details_batch_id: null
                                };
                            }
                        });

                        console.log('merged', mergedArray);
                        const updatedItems = mergedArray.map(item => ({
                            ...item,
                            remaining_batch_quantity: Number(item?.batch_quantity) - Number(item.returned_quantity)
                        }));

                        setRouteReturnData(updatedItems || []);
                    } else {
                        showMessage('error', 'No batch data found for this route');
                        setRouteReturnData([]);

                    }
                }
            } else {
                setRouteReturnData([])
                showMessage('error', res?.message);
            }
        } catch (err) {
            console.log(err);
            showMessage('error', 'something went wrong')
        } finally {
            hideLoading(layoutDispatch)
        }
    };

    const infoItems = [
        // { label: 'Date', value: deliveryDate ? moment(deliveryDate).format('DD-MM-YYYY') : '', type: 'text', color: '#1677ff' },
        { label: 'Route', value: `${selectedRoute?.title} (${selectedRoute?.code})`, type: 'text', color: '#1677ff' },
        { label: 'Driver', value: `${selectedRoute?.driver_name ? selectedRoute?.driver_name : ''}`, type: 'text', color: '#1677ff' },
        { label: 'Vehicle', value: `${selectedRoute?.registration_number ? selectedRoute?.registration_number : ''}`, type: 'text', color: '#1677ff' },
    ];

    const items = [

        {
            key: '1',
            label: 'Goods Return',
            children: routeReturnData.length > 0
                ? (
                    <GoodsReturnTab
                        routeReturnData={routeReturnData}
                        setRouteReturnData={setRouteReturnData}
                        selectedRoute={selectedRoute}
                        handleCloseDrawer={handleCloseDrawer}
                    />
                )
                : (
                    <Result status="404" subTitle="Sorry, no data exists." />

                ),
        },
        {
            key: '2',
            label: 'Stock Discrepancies',
            children: routeReturnData.length > 0
                ? (
                    <StockDiscrepancyTab
                        routeReturnData={routeReturnData}
                        setRouteReturnData={setRouteReturnData}
                        selectedRoute={selectedRoute}
                        handleCloseDrawer={handleCloseDrawer}
                    />
                )
                : (
                    <Result status="404" subTitle="Sorry, no data exists." />
                ),
        },
    ];


    return (
        <>
            <Drawer
                open={drawerOpen}
                onClose={handleCloseDrawer}
                height="100vh"
                title={
                    <>
                        <Flex justify='space-between' wrap>
                            <Text style={{ fontSize: '18px', fontWeight: '500', color: '#1890ff' }}>Route Returns</Text>
                            <Flex gap={5} align="center" wrap>
                                <Tag icon={selectedRoute?.route_returned_by > 0 ? <CheckOutlined /> : <CloseOutlined />} style={{ fontSize: 16, fontWeight: 400, padding: 3 }} color={selectedRoute?.route_returned_by > 0 ? 'green' : 'volcano'}>Route Returned</Tag>
                                <Tag icon={selectedRoute?.route_returned_posted_by > 0 ? <CheckOutlined /> : <CloseOutlined />} style={{ fontSize: 16, fontWeight: 400, padding: 3 }} color={selectedRoute?.route_returned_posted_by > 0 ? 'green' : 'volcano'} >Stock Discrepancies</Tag>
                                <Tag icon={<InfoCircleOutlined />} color='blue' style={{ fontSize: 16, fontWeight: 400, padding: 3 }}>Date: <span style={{ fontWeight: 'bold' }}>{dayjs(deliveryDate).format('DD-MM-YYYY')}</span></Tag>
                            </Flex>
                        </Flex>
                    </>
                }
                placement={"bottom"}
                bodyStyle={{ padding: '10px' }}
            >
                <DetailsGrid infoItems={infoItems} size={'small'} />
                <Tabs type="card" style={{ background: 'white', height: '100%', overflowY: 'scroll', marginTop: 10 }} activeKey={activeTab} onChange={onTabChange} centered
                    items={items}
                />
            </Drawer>
        </>
    )
}

export default ReturnDrawer